import { useState } from "react";
import "./AcoesFormulario.css";
import { Modal, Button, OverlayTrigger, Tooltip } from "react-bootstrap";

const AcoesFormulario = ({
  onSalvar,
  onEnviar,
  onEnviarCorrecao,
  hasCorrecao = false,
  esconder = false,
  desabilitar = false,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [acaoSelecionada, setAcaoSelecionada] = useState("");

  if (esconder) return null;

  const handleClick = (acao) => {
    if (desabilitar) return;

    if (acao === "ENVIAR") {
      onEnviar?.();
      return;
    }
    if (acao === "ENVIAR_CORRECAO") {
      (onEnviarCorrecao || onEnviar)?.();
      return;
    }

    setAcaoSelecionada(acao);
    setShowModal(true);
  };

  const handleConfirmar = () => {
    setShowModal(false);
    if (acaoSelecionada === "SALVAR") onSalvar?.();
  };

  const isSalvar = acaoSelecionada === "SALVAR";

  const textoSalvar =
    'Ao clicar em "Salvar", as informações serão salvas no sistema para posterior envio ao Desenvolvimento Sindical. Deseja realmente salvar a documentação?';

  const corpoModal = isSalvar ? textoSalvar : "";

  const titulo = "Confirmar SALVAR";

  const Btn = ({ children, onClick, className }) => (
    <OverlayTrigger
      placement="top"
      overlay={
        desabilitar ? (
          <Tooltip id="tt-acoes-bloqueadas">
            Ações indisponíveis enquanto sua solicitação está em análise.
          </Tooltip>
        ) : (
          <></>
        )
      }
    >
      <span className="d-inline-block">
        <button
          className={className}
          onClick={onClick}
          disabled={desabilitar}
          style={desabilitar ? { pointerEvents: "none" } : undefined}
        >
          {children}
        </button>
      </span>
    </OverlayTrigger>
  );

  return (
    <div className="acoes-formulario d-flex justify-content-end gap-3 mt-4">
      <Btn
        className="btn btn-salvar btn-acao"
        onClick={() => handleClick("SALVAR")}
      >
        SALVAR
      </Btn>

      {!hasCorrecao ? (
        <Btn
          className="btn btn-enviar btn-acao"
          onClick={() => handleClick("ENVIAR")}
        >
          ENVIAR
        </Btn>
      ) : (
        <Btn
          className="btn btn-enviar btn-acao"
          onClick={() => handleClick("ENVIAR_CORRECAO")}
        >
          ENVIAR CORREÇÃO
        </Btn>
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="text-primary fw-bold">{titulo}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="mb-0">{corpoModal}</p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button className="btn-confirmar" onClick={handleConfirmar}>
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AcoesFormulario;
